import { PodiumFeatures } from '../../constans/common-constants';
import PermissionsStore from '../../store/permissions-store/permissions-store';

const { PRESENTER, ATTENDEES, QANDA, POLLS, BLANK } = PodiumFeatures;

export const getDefaultRoutePathByPermissions = (permissionsStore: PermissionsStore): string => {
  permissionsStore.getPermissions();
  return getDefaultRouteRedirectPath(permissionsStore);
};

export const getDefaultRouteRedirectPath = ({
  isPodiumSlidesEnabled,
  isPodiumPollsEnabled,
  isPodiumAttendeesEnabled,
  isPodiumQandaEnabled,
  isPodiumEnabled,
  isPodiumPresenterQuestionsEnabled
}: PermissionsStore): string => {
  if (isPodiumSlidesEnabled() || isPodiumPresenterQuestionsEnabled()) {
    return PRESENTER.path;
  } else if (isPodiumAttendeesEnabled()) {
    return ATTENDEES.path;
  } else if (isPodiumQandaEnabled() && isPodiumEnabled()) {
    return QANDA.path;
  } else if (isPodiumPollsEnabled()) {
    return POLLS.path;
  } else {
    return BLANK.path;
  }
};